export default {"src":"/_next/static/media/pb.174dc634.svg","height":26,"width":172,"blurWidth":0,"blurHeight":0};